export default __webpack_public_path__ + "static/media/eventDashboard_cctv.6c1ce063.svg";